import * as actions from 'actions';
import pagingMaker from 'reducersMakers/pagingMaker';
import byKeyMaker from 'reducersMakers/byKeyMaker';

export default byKeyMaker('searchQueryString',
  pagingMaker({
    fetchType: actions.SEARCH_ITEMS_FETCH,
    fetchSuccessType: actions.SEARCH_RESULTS_RECEIVED,
    fetchErrorType: actions.SEARCH_ITEMS_FETCH_ERROR,
    possiblePageUpdateType: actions.SEARCH_UPDATE_POSSIBLE_PAGE
  })
);



/** WEBPACK FOOTER **
 ** ./src/members/state/search/paging/results/byQuery/reducer.js
 **/